import React, { Component } from 'react'
import HeaderBar from '../components/HeaderBar'

export default function withHeader(WrappedComponent, props) {

  const HOC = class extends Component {
    render() {
      return <React.Fragment>
        <HeaderBar {...this.props} />
        {
          this.props.store.is_search_bar_toggled
            ? null
            : <WrappedComponent {...this.props} />
        }
      </React.Fragment>
    }
  }
  return HOC
}



// WEBPACK FOOTER //
// ./src/lib/withHeader.js